import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
export const InventoryLotsRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./index/inventory-lots-list.component').then(
            (m) => m.InventoryLotsListComponent
          ),
      },
      {
        path: 'registro',
        loadComponent: () =>
          import('./register/inventory-lots-register.component').then(
            (m) => m.InventoryLotsRegisterComponent
          ),
      },
      {
        path: 'detalle/:id',
        loadComponent: () =>
          import('./detail/index/list-serial-code.component').then(
            (m) => m.ListSerialCodeInventoryLotsComponent
          ),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(InventoryLotsRoutes)],
  exports: [RouterModule],
})
export class InventoryLotsRoutingModule {}
